import http from '../utils/request.js' // 导入封装好的axios实例

const BASE_URL = 'https://xq-openapi.ledrift.net'

// 系统服务接口
export const systemServiceApi = {
	/**
	 * 获取车型参数
	 * @param {string} modelId - 车型ID
	 * @returns {Promise} 包含车型参数的Promise
	 */
	getModelParams(modelId) {
		return http.post(`${BASE_URL}/system/service/getModelParams`, {
			id: modelId
		}, {
			showLoading: true,
			loadingText: '加载中...',
			showError: true
		})
	},

	/**
	 * 获取车辆合格证书PDF
	 * @param {string} motoId - 车辆ID
	 * @returns {Promise} 包含PDF URL的Promise
	 */
	getMotoCertPdf(motoId) {
		return http.post(`${BASE_URL}/system/service/getMotoCertPdf`, {
			motoId
		}, {
			showLoading: true,
			loadingText: '加载合格证书...',
			showError: true
		})
	},

	/**
	 * 获取客户列表
	 * @param {Object} params - 请求参数
	 * @returns {Promise} 包含客户列表的Promise
	 */
	getCustomerLists(params) {
		return http.post(`${BASE_URL}/system/service/getCustomerLists`, params, {
			showLoading: true,
			loadingText: '加载中...',
			showError: true
		})
	},
	/**
	 * 提交试驾申请
	 * @param {Object} params - 试驾申请参数
	 * @returns {Promise} 提交结果的Promise
	 */
	
	testDrive(params) {
		return http.post(`${BASE_URL}/system/homepage/testDrive`, params, {
			showLoading: true,
			loadingText: '提交中...',
			showError: true
		})
	},
	/**
	 * 获取客户详细信息
	 * @param {Object} params - 请求参数
	 * @returns {Promise} 包含客户信息的Promise
	 */
	getCustomerInfos(params) {
		return http.post(`${BASE_URL}/system/service/getCustomerInfos`, params, {
			showLoading: true,
			loadingText: '加载中...',
			showError: true
		})
	},

	/**
	 * 创建工单
	 * @param {Object} params - 工单创建参数（对应原this.newForm）
	 * @returns {Promise} 工单创建结果的Promise
	 */
	createWorkOrder(params) {
		return http.post(`${BASE_URL}/system/service/createWorkOrder`, params, {
			showLoading: true,
			loadingText: '提交中...',
			showError: true
		})
	},

	/**
	 * 完成工单时间处理
	 * @param {Object} params - 工单处理参数（对应原this.closeFrom）
	 * @returns {Promise} 处理结果的Promise
	 */
	completeTimeWorkOrder(params) {
		return http.post(`${BASE_URL}/system/service/completeTimeWorkOrder`, params, {
			showLoading: true,
			loadingText: '处理中...',
			showError: true
		})
	},

	/**
	 * 获取文件上传URL
	 * @param {Object} params - 包含文件后缀和文件类型的参数对象
	 * @param {string} params.fileSuffix - 文件后缀名
	 * @param {number} params.fileType - 文件类型（0表示默认类型）
	 * @returns {Promise} 包含上传URL的Promise
	 */
	getUploadUrl(params) {
		return http.post(`${BASE_URL}/file/getUploadUrl`, {
			params
		})
	},
	/**
	 * 获取当前客户信息
	 * @returns {Promise} 包含当前客户信息的Promise
	 */
	getCurrentCustomer() {
		return http.post(`${BASE_URL}/system/service/getCurrentCustomer`, {}, {
			showLoading: true,
			loadingText: '加载中...',
			showError: true
		})
	},
	/**
	 * 创建维修记录
	 * @param {Object} params - 维修记录参数（对应原this.newForm）
	 * @returns {Promise} 维修记录创建结果的Promise
	 */
	createRepair(params) {
		return http.post(`${BASE_URL}/system/service/createRepair`, params, {
			showLoading: true,
			loadingText: '提交中...',
			showError: true
		})
	}
}

// 导出所有接口
export default {
	systemServiceApi
}